import React, { useState } from 'react';
import { T } from 'services/lang/LanguageService';
import { useGetAlertsHistory } from "api/api-hooks/alert-fan-hooks";
import { Button } from "primereact/button";
import { Chips } from "primereact/chips";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import { ChronoUnitLegacy, addToDate } from "utils/time-utils";
import CalendarWrapper from "../../basic/calendar-wrapper/CalendarWrapper";
import HistoryTagsTable from "./HistoryTagsTable";

type TagsHistoryType = {
  dialog: boolean;
  showDialog: (val: boolean) => void;
  tags?: string[];
};

const TagsHistory = ({ tags: givenTags, dialog, showDialog }: TagsHistoryType) => {
  const [includeTags, setIncludeTags] = useState<string[]>(givenTags || []);
  const [excludeTags, setExcludeTags] = useState<string[]>([]);
  const [searchText, setSearchText] = useState("");

  const [dateFrom, setDateFrom] = useState(addToDate(new Date(), -1, ChronoUnitLegacy.DAYS));
  const [dateTo, setDateTo] = useState(new Date());

  const { data, isLoading, error, refetch } = useGetAlertsHistory(
    {
      containingTags: includeTags,
      notContainingTags: excludeTags,
      searchText,
      start: dateFrom.toISOString(),
      end: dateTo.toISOString(),
    },
    { enabled: false }
  );
  return (
    <Dialog
      onHide={() => showDialog(false)}
      visible={dialog}
      header={T("label.tags-history")}
    >
      <div className="flex flex-column gap-2">
        <div className="flex flex-column gap-2">
          <div className="flex flex-column">
            <b>{T("action.include-tags")}</b>
            <div className="p-fluid">
              <Chips value={includeTags} onChange={e => setIncludeTags(e.value)} addOnBlur />
            </div>
          </div>
          <div className="flex flex-column">
            <b>{T("action.exclude-tags")}</b>
            <div className="p-fluid">
              <Chips value={excludeTags} onChange={e => setExcludeTags(e.value)} addOnBlur />
            </div>
          </div>
          <div className="flex gap-2">
            <div className="flex flex-column">
              <b>{T("word.starts-at")}</b>
              <CalendarWrapper value={dateFrom} onChange={setDateFrom} />
            </div>
            <div className="flex flex-column">
              <b>{T("word.ends-at")}</b>
              <CalendarWrapper value={dateTo} onChange={setDateTo} />
            </div>
          </div>
          <div className="flex flex-column">
            <b>{T("action.search")}</b>
            <InputText value={searchText} onChange={e => setSearchText(e.target.value)} />
          </div>
          <Button label={T("action.search")} onClick={() => refetch()} />
        </div>
        {error && <div style={{ border: "1px solid red" }}>{T("error.alert-fan.error-while-fetching-alerts")}</div>}
        {isLoading && !error && <ProgressSpinner style={{ overflow: "hidden" }} />}
        {!isLoading && !error && <HistoryTagsTable data={data || []} />}
      </div>
    </Dialog>
  );
};

export default TagsHistory;